// @ts-nocheck 06b0ad3e
import actionTypes from './developerToolBarActionTypes';

const override = (overrides) => ({ type: actionTypes.OVERRIDE, overrides });

export { override };
